var HOURS_IN_DAY = 24;
var MINUTES_IN_HOUR = 60;
var SECONDS_IN_MINUTE = 60;
var convertDaysToMilliseconds = function convertDaysToMilliseconds(days) {
  return days * HOURS_IN_DAY * MINUTES_IN_HOUR * SECONDS_IN_MINUTE * 1000;
};
export var setCookies = function setCookies(name, value, days, domain) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + convertDaysToMilliseconds(days));
    expires = "; expires=".concat(date.toUTCString());
  }
  document.cookie = "".concat(name, "=").concat(value || '', "; domain=").concat(domain || '').concat(expires, "; path=/");
};
export var readCookies = function readCookies(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.includes(nameEQ)) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};